import { API } from "../lib/api";

const initials = (n) => (n || "?").split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

/**
 * Compact avatar bubble — renders the user's uploaded avatar_image if present,
 * else neon initials. Used in feed, friends list, team grid, comments, DMs.
 *
 * Props:
 *   - name: display name (for fallback initials + alt text)
 *   - image: optional file_id (NOT a full URL) — fetched via /api/files/{id}
 *   - size: pixel size (default 28)
 *   - ringColor: optional CSS color for the ring (defaults to subtle white)
 *   - className: extra classes
 *   - testId: optional data-testid for tests
 */
export default function Avatar({ name, image, size = 28, ringColor, className = "", testId }) {
  const style = {
    width: size,
    height: size,
    borderColor: ringColor || "rgba(255,255,255,0.15)",
  };
  return (
    <div
      data-testid={testId}
      style={style}
      className={`rounded-full border overflow-hidden shrink-0 bg-background flex items-center justify-center ${className}`}
      aria-label={name}
    >
      {image ? (
        <img
          src={`${API}/files/${image}`}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
      ) : (
        <span
          className="font-display text-neon-pink"
          style={{ fontSize: Math.max(10, Math.round(size * 0.4)) }}
        >
          {initials(name)}
        </span>
      )}
    </div>
  );
}
